import actions from "./actions";

const {FETCH_QUARTER, FETCH_QUARTER_ATTENDANCE} = actions;
const initState = {
    quarter: [],
    quarterAttendance: [],
};

const QuartersReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_QUARTER:
            return {
                ...state,
                quarter: data
            }
        case FETCH_QUARTER_ATTENDANCE:
            return {
                ...state,
                quarterAttendance: data
            }
        default:
            return state;
    }
}

export default QuartersReducer;
